import { __awaiter } from "tslib";
import React from 'react';
import { createStore } from '@souche-f2e/muji';
import Api from '@/services';
import { dispatch } from '@@/store';
import { showInfo } from '@/components';
import { showCarDetail, fontEndConfig } from '@/shared/utils';
import { judgeObj, judgeArr, dealValueShow, thousandBitSeparator } from '@/shared/functions';
import { showContract } from '@/shared/utils';
import Authorized from '@/components/Auth/auth';
import styles from '@/style/color.less';
import { dealSourceType } from '@/pages/Finance/PayManage/_components/functions';
import { Modal, notification } from 'antd';
import Purchase from '@/pages/Finance/PayManage/_components/Purchase';
/**
 *  @desc 操作列
 */
const _opt = {
    title: '操作',
    dataIndex: 'option',
};
/**
 *  @desc 操作列 待付款dom
 */
const _noPay = (record) => {
    return (<div className={'table-operate-btn'}>
      <Authorized allow={'psgjb-finanbupayment-contrview'}>
        <a href="javascript:;" onClick={() => dispatch.payBuyer.seeContract(record)}>
          查看合同
        </a>
      </Authorized>
      <Authorized allow={'psgjb-finanbupayment-affirm'}>
        <a href="javascript:;" onClick={() => dispatch.payBuyer.confirmPay(record)}>
          付款确认
        </a>
      </Authorized>
      <a href="javascript:;" onClick={() => dispatch.payBuyer.invalidPay(record)}>
        作废收款
      </a>
    </div>);
};
/**
 *  @desc 操作列 已付款dom
 */
const _payed = (record) => {
    return (<div className={'table-operate-btn'}>
      <Authorized allow={'psgjb-finanbupayment-contrview'}>
        <a href="javascript:;" onClick={() => dispatch.payBuyer.seeContract(record)}>
          查看合同
        </a>
      </Authorized>
      <a href="javascript:;" onClick={() => showInfo('pay', record.orderId)}>
        付款明细
      </a>
    </div>);
};
/**
 *  @desc 接口公共数据
 */
const _common = (data) => {
    const { i, pageCurrent, v } = data;
    return {
        key: i,
        number: pageCurrent * 20 - 19 + i,
        orderId: dealValueShow(v.orderId),
        carType: dealValueShow(v.goodsName),
        address: dealValueShow(v.carLocation),
        seller: dealValueShow(v.sellerName),
        sellerCode: dealValueShow(v.sellerCode),
        carNum: dealValueShow(v.carLicense),
        buyer: dealValueShow(v.buyerName),
        buyerCode: dealValueShow(v.buyerCode),
        dealPrice: dealValueShow(thousandBitSeparator(v.sellerPriceYuanUnit)),
        servicePrice: dealValueShow(thousandBitSeparator(v.commissionYuanUnit)),
        commission: dealValueShow(thousandBitSeparator(v.brokerageYuanUnit)),
        handPrice: dealValueShow(thousandBitSeparator(v.totalPriceYuanUnit)),
        goodsId: v.goodsId,
        hPYuan: v.totalPriceYuanUnit,
        carVin: dealValueShow(v.carVin),
        sourceType: v.sourceType,
        receiveNum: v.receiveNum,
    };
};
const initState = {
    columns: [
        {
            title: '序列',
            dataIndex: 'number',
            width: 82,
        }, {
            title: '订单信息',
            width: 358,
            render: (text, record, index) => {
                const { orderId, goodsId, carType, carVin, carNum, address, sourceType } = record;
                return (<>
            订单号：{orderId}<br />
            <a href="javascript:;" onClick={() => {
                    goodsId && showCarDetail(goodsId);
                }}>
              {carType}
            </a><br />
            VIN码：{carVin}<br />
            <div className="flex__row-start" style={{ marginTop: '8px' }}>
              <div className={`${styles['uIDesign--dealType']}`} style={{ marginRight: '8px' }}>
                {dealSourceType(sourceType)}
              </div>
              <div className={`${styles.uIDesign_orange}`} style={{ marginRight: '8px' }}>
                {carNum}
              </div>
              <div className={`${styles.uIDesign_blue}`}>
                {address}
              </div>
            </div>
          </>);
            },
        }, {
            title: '买卖家信息',
            width: 230,
            render: (text, record, index) => {
                const { buyer, seller, buyerCode, sellerCode } = record;
                return (<>
            买家经销商：
              {buyerCode ?
                    <a href="javascript:;" onClick={() => showInfo('buyer', buyerCode)}>
                  {buyer}
                </a> : buyer}
            <br />
            卖家经销商：
              {sellerCode ?
                    <a href="javascript:;" onClick={() => showInfo('seller', sellerCode)}>
                  {seller}
                </a> : seller}
            <br />
          </>);
            },
        }, {
            title: '价格信息(元)',
            width: 254,
            render: (text, record, index) => {
                const { dealPrice, handPrice, commission, servicePrice } = record;
                return (<>
            成交价 {dealPrice}<br />
            合手价 {handPrice}<br />
            <div className="flex__row-start" style={{ marginTop: '8px' }}>
              <div className={`${styles.uIDesign_orange}`} style={{ marginRight: '8px' }}>
                佣金{commission}
              </div>
              <div className={`${styles.uIDesign_blue}`}>
                服务费{servicePrice}
              </div>
            </div>
          </>);
            },
        }, {
            title: '更新时间',
            width: 110,
            render: (text, record, index) => {
                const { userDefine_updateTime: time } = record;
                const _dealTime = time.split(' ');
                return (<>{_dealTime[0]}<br />{_dealTime[1]}</>);
            },
        }, {
            title: '采购信息',
            width: 100,
            render: (text, record, index) => (<Purchase orderId={record.orderId}/>),
        },
        Object.assign(Object.assign({}, _opt), { width: 167, render: (text, record, index) => {
                switch (record.optType) {
                    case 'noPay':
                        return _noPay(record);
                    case 'payed':
                        return _payed(record);
                    default:
                        return fontEndConfig.noValueReplace;
                }
            } })
    ],
    data: [],
    totalNum: 0,
    options: [
        { label: '全部付款状态', value: 'all' },
        { label: '待付款', value: 'noPay' },
        { label: '已付款', value: 'payed' },
    ],
    showPayConfirm: false,
    choosedOpt: 'all',
    pageCurrent: 1,
    pageSize: 20,
    choosedOrderId: '',
    choosedHandPrice: 0,
    tableLoading: false,
};
export default createStore({
    state: Object.assign({}, initState),
    effects: {
        /**
         * @desc 加载列表
         */
        load(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { choosedOpt, pageCurrent, pageSize } = rootState.payBuyer;
                const { topParams } = rootState.payTop;
                console.log(topParams);
                const _param = Object.assign({ pageCurrent,
                    pageSize }, topParams);
                this.SET_STATE({ tableLoading: true });
                let _r;
                switch (choosedOpt) {
                    case 'all':
                        _r = yield this.buyerAll(_param);
                        break;
                    case 'noPay':
                        _r = yield this.buyerNoPay(_param);
                        break;
                    case 'payed':
                        _r = yield this.buyerPayed(_param);
                        break;
                    default:
                        _r = { items: [], totalNum: 0 };
                        console.warn('买家付款下拉类型错误');
                }
                this.SET_STATE({ tableLoading: false });
                this.SET_STATE({
                    data: _r.items,
                    totalNum: _r.totalNum,
                });
            });
        },
        /**
         * @desc 买家全部接口
         */
        buyerAll(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { pageCurrent } = rootState.payBuyer;
                const result = { totalNum: 0, items: [] };
                return Api.order.getOrderAll(payload).then((res) => {
                    const data = JSON.parse(JSON.stringify(res));
                    if (!judgeObj(data) || !judgeArr(data.items)) {
                        return result;
                    }
                    result.totalNum = data.totalNumber;
                    result.items = data.items.map((v, i) => {
                        const _temp = {};
                        switch (v.recStatus) {
                            case 0: // 待付款
                                _temp.userDefine_updateTime = dealValueShow(v.incomeModifyTime || v.createTime);
                                _temp.optType = 'noPay';
                                break;
                            default: // 1: 已付款 2: 部分付款（后端新增支持项，目前不涉及）
                                _temp.userDefine_updateTime = dealValueShow(v.payTime);
                                _temp.optType = 'payed';
                        }
                        const _item = Object.assign(Object.assign({}, _common({ i, v, pageCurrent })), _temp);
                        return _item;
                    });
                    return result;
                }).catch((err) => {
                    console.log(err);
                    return result;
                });
            });
        },
        /**
         * @desc 买家待付款接口
         */
        buyerNoPay(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { pageCurrent } = rootState.payBuyer;
                const result = { totalNum: 0, items: [] };
                return Api.order.getOrderNoPay(payload).then((res) => {
                    const data = JSON.parse(JSON.stringify(res));
                    if (!judgeObj(data) || !judgeArr(data.items)) {
                        return result;
                    }
                    result.totalNum = data.totalNumber;
                    result.items = data.items.map((v, i) => {
                        const _item = Object.assign(Object.assign({}, _common({ i, v, pageCurrent })), { userDefine_updateTime: dealValueShow(v.incomeModifyTime || v.createTime), optType: 'noPay' });
                        return _item;
                    });
                    return result;
                }).catch((err) => {
                    console.log(err);
                    return result;
                });
            });
        },
        /**
         * @desc 买家已付款接口
         */
        buyerPayed(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const result = { totalNum: 0, items: [] };
                const { pageCurrent } = rootState.payBuyer;
                return Api.order.getOrderTBRViewList(payload).then((res) => {
                    const data = JSON.parse(JSON.stringify(res));
                    if (!judgeObj(data) || !judgeArr(data.items)) {
                        return result;
                    }
                    result.totalNum = data.totalNumber;
                    result.items = data.items.map((v, i) => {
                        const _item = Object.assign(Object.assign({}, _common({ i, v, pageCurrent })), { userDefine_updateTime: dealValueShow(v.payTime), optType: 'payed' });
                        return _item;
                    });
                    return result;
                }).catch((err) => {
                    console.log(err);
                    return result;
                });
            });
        },
        /**
         * @desc 付款确认
         */
        confirmPay(payload, { update, state, rootState }) {
            const { hPYuan, receiveNum } = payload;
            if (receiveNum && hPYuan) {
                this.SET_CHOOSE_ORDERID(receiveNum);
                this.SET_CHOOSE_HANDPRICE(hPYuan);
                dispatch.payMoneyModal.getPayRadios({});
                this.SHOW_PAYCONFIRM();
            }
        },
        /**
         * @desc 查看合同
         */
        seeContract(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { orderId } = payload;
                if (orderId) {
                    showContract({
                        orderId,
                    });
                }
            });
        },
        /**
         * @desc 作废收款
         */
        invalidPay(payload, { update, state, rootState }) {
            const { receiveNum } = payload;
            Modal.confirm({
                title: '是否确认作废收款？',
                content: '',
                onOk() {
                    Api.finance.cancelBuyerPay({ receiveNum }).then((_r) => {
                        if (_r) {
                            // 成功之后就展示作废收款成功
                            notification.success({
                                message: '操作成功！',
                            });
                            // 刷新页面
                            dispatch.payBuyer.SET_PAGE_CURRENT(1);
                            dispatch.payBuyer.load({});
                        }
                    });
                },
            });
        },
        /**
         * @desc 搜索列表  更改下拉选项
         */
        onChange(payload, { update, state, rootState }) {
            // 更改下拉选项
            this.SET_CHOOSED_OPT(payload);
        },
    },
    reducers: {
        RESET_STATE() {
            return Object.assign({}, initState);
        },
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (initState[key] !== undefined) {
                    state[key] = payload[key];
                }
            });
        },
        SHOW_PAYCONFIRM(state) {
            state.showPayConfirm = true;
        },
        HIDE_PAYCONFIRM(state) {
            state.showPayConfirm = false;
        },
        SET_CHOOSED_OPT(state, payload) {
            state.choosedOpt = payload;
        },
        SET_PAGE_CURRENT(state, payload) {
            state.pageCurrent = payload;
        },
        SET_CHOOSE_ORDERID(state, payload) {
            state.choosedOrderId = payload;
        },
        SET_CHOOSE_HANDPRICE(state, payload) {
            state.choosedHandPrice = payload;
        },
    },
});
